"use client";

import Link, { type LinkProps } from "next/link";
import { usePostHog } from "posthog-js/react";
import type { ComponentPropsWithoutRef, ReactNode } from "react";

import {
  captureCtaClick,
  type CtaLocation,
} from "../../_components/cta-tracking";
import type { AudienceSlug } from "../_config/audiences";

type AnchorProps = Omit<
  ComponentPropsWithoutRef<"a">,
  keyof LinkProps | "children"
>;

interface TrackedCtaLinkProps extends AnchorProps, LinkProps {
  audience: AudienceSlug;
  ctaLocation: CtaLocation;
  children: ReactNode;
}

export function TrackedCtaLink({
  audience,
  ctaLocation,
  onClick,
  ...rest
}: TrackedCtaLinkProps) {
  const posthog = usePostHog();

  return (
    <Link
      {...rest}
      onClick={(e) => {
        captureCtaClick(posthog, { audience, ctaLocation });
        onClick?.(e);
      }}
    />
  );
}
